import { getUrlParameterByName } from './url-service';
import { LOCALIZATION } from './../constants/localization-constants';

export const locale = key => {
    const locale = getUrlParameterByName('locale') || 'en';
    return LOCALIZATION[locale].has(key)
        ? LOCALIZATION[locale].get(key)
        : key;
};
